import { routes } from "../../../constants/routes";
import * as Yup from "yup";

export const ordersBreadcrumbLink = [
  {
    label: "Order Management",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "Orders",
    link: routes.ORDERSLIST,
    handleClick: () => {},
  },
];
export const invoiceBreadcrumbLink = [
  {
    label: "Order Management",
    link: routes.INVOICELIST,
    handleClick: () => {},
  },
  {
    label: "Invoices",
    link: routes.INVOICELIST,
    handleClick: () => {},
  },
];

export const getInvoicesListHeaders = () => {
  return [
    { key: "invoiceId", label: "Invoice ID", isSortable: true },
    { key: "orderId", label: "Order ID", isSortable: true },
    { key: "companyName", label: "Company", isSortable: true },
    { key: "status", label: "Status", isSortable: true },
    { key: "totalAmount", label: "Amount", isSortable: true },
    { key: "invoiceDate", label: "Invoice Date", isSortable: true },
    { key: "dueDate", label: "Due Date", isSortable: true },
    { key: "transactions", label: "Transactions", isSortable: true },
  ];
};
export const getOrdersListHeaders = () => {
  return [
    { key: "orderId", label: "Order ID", isSortable: true },
    { key: "companyName", label: "Company", isSortable: true },
    { key: "customer", label: "Customer", isSortable: true },
    { key: "orderDate", label: "Order Date", isSortable: true },
    { key: "orderStatus", label: "Order Status", isSortable: true },
    { key: "paymentStatus", label: "Payment Status", isSortable: true },
    { key: "totalAmount", label: "Total Amount", isSortable: true },
    { key: "planName", label: "Plan", isSortable: true },
    { key: "invoiceCount", label: "Invoice Count", isSortable: true },
    { key: "planType", label: "Frequency", isSortable: true },
  ];
};
export const getTransactionListHeaders = () => {
  return [
    { key: "customerName", label: "Customer", isSortable: true },
    { key: "transactionId", label: "Transaction ID", isSortable: true },
    { key: "dataTime", label: "Date & Time", isSortable: true },
    { key: "totalAmount", label: "Amount", isSortable: true },
    { key: "paymentMethod", label: "Payment Method", isSortable: true },
    { key: "status", label: "Status", isSortable: true },
  ];
};
export const getOrderInvoiceHeaders = () => {
  return [
    { key: "invoiceId", label: "Invoice ID" },
    { key: "dataTime", label: "Date & Time" },
    { key: "status", label: "Status" },
    { key: "action", label: "Action" },
  ];
};

export const orderValidationSchema = Yup.object().shape({
  orderId: Yup.string().required("Order ID is required"),
  status: Yup.string().required("Order status is required"),
  tenantId: Yup.string().required("Company is required"),
  customer: Yup.string().required("Customer is required"),
  paymentStatus: Yup.string(),
  totalAmount: Yup.number()
    .typeError("Total amount must be a number")
    .required("Total amount is required"),
  selectedPlan: Yup.string().required("Plan is required"),
  planFrequency: Yup.string().required("Plan frequency is required"),
  createdOn: Yup.date().typeError("Invalid date").nullable(),
});

export const orderFilterOptions = [
  { label: "Company Name", value: false },
  { label: "Order Date", value: false },
  { label: "Payment Status", value: false },
  { label: "Order Status", value: false },
  { label: "Plan Name", value: false },
  { label: "Plan Frequency", value: false },
];
export const invoiceFilterOptions = [
  { label: "Company Name", value: false },
  { label: "Status", value: false },
  { label: "Amount", value: false },
  { label: "Invoice Date", value: false },
  { label: "Due Date", value: false },
  { label: "Transactions", value: false },
];
export const transactionFilterOptions = [
  { label: "Amount", value: false },
  { label: "Date Range", value: false },
  { label: "Status", value: false },
];

export const PAYMENT_STATUS_OPTIONS = [
  "Unpaid",
  "Paid",
  "Partially_paid",
  "Overdue",
  "Refunded",
  "Cancelled",
];
export const ORDER_STATUS_OPTIONS = [
  "Draft",
  "Pending_approval",
  "Active",
  "On_hold",
  "Suspended",
  "Cancelled",
  "Completed",
];

export const PLANTYPE_OPTIONS = ["monthly", "annually", "14 Days"];

export const PLAN_NAME_OPTIONS = [
  "Basic",
  "Professional",
  "Enterprise",
  "Starter",
  "No Cost",
  "Trial",
];

export const INVOICE_STATUS_OPTIONS = [
  "DRAFT",
  "PAID",
  "OVERDUE",
  "REFUNDED",
  "SENT",
  "VIEWED",
  "PARTIAL_PAYMENT",
  "FAILED",
  "WRITTEN_OFF",
];

export const TRANSACTION_STATUS_OPTIONS = [
  "Initiated",
  "Processing",
  "Completed",
  "Declined",
  "Void",
];

export const ORDER_STATUS = [
  { value: "Draft" },
  { value: "Pending_approval" },
  { value: "Active" },
  { value: "Suspended" },
];

export const PAYMENT_STATUS = [
  { label: "Unpaid", value: "Unpaid" },
  { label: "Paid", value: "Paid" },
  { label: "Overdue", value: "Overdue" },
  { label: "Refunded", value: "Refunded" },
  { label: "Cancelled", value: "Cancelled" },
];

export const PLAN_NAMES = [
  { label: "Basic", value: "Basic" },
  { label: "Professional", value: "Professional" },
  { label: "Enterprise", value: "Enterprise" },
  { label: "Starter", value: "Starter" },
  { label: "No Cost", value: "No Cost" },
  { label: "Trial", value: "Trial" },
];

export const PLANTYPES = [
  { label: "Monthly", value: "monthly" },
  { label: "Annually", value: "annually" },
  { label: "14 Days", value: "14 days" },
];

export const INVOICE_STATUS = [
  { label: "Draft", value: "DRAFT" },
  { label: "Paid", value: "PAID" },
  { label: "Overdue", value: "OVERDUE" },
  { label: "Sent", value: "SENT" },
  { label: "Failed", value: "FAILED" },
  { label: "Written Off", value: "WRITTEN OFF" },
];

export const ADJUSTMENT_TYPE_OPTIONS = [
  { label: "Discount", value: "DISCOUNT" },
  { label: "Refund", value: "REFUND" },
  { label: "Credit Note", value: "CREDIT NOTE" },
  { label: "Debit Note", value: "DEBIT NOTE" },
];
